import script from "./AddStoriesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddStoriesPage.vue?vue&type=script&setup=true&lang=ts"

import "./AddStoriesPage.vue?vue&type=style&index=0&id=5bece7e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5bece7e1"]])

export default __exports__